module.exports = __webpack_public_path__ + "assets/img/18_921.e9a33490.jpg";